module.exports = __webpack_public_path__ + "img/bathroom_fitter.e5854342.png";